import Header from "./components/Header/Header";
import Hero from "./components/Hero/Hero";
import Features from "./components/Features/Features";
import HowItWorks from "./components/HowItWorks/HowItWorks";
import Team from "./components/Team/Team";
import InTheMedia from "./components/InTheMedia/InTheMedia";
import MobileApp from "./components/MobileApp/MobileApp";
import Footer from "./components/Footer/Footer";
import Business from "./components/Business/Business";
import FAQ from "./components/FAQ/FAQ";

function App() {
  return (
    <>
      <Header></Header>
      <Hero></Hero>
      <Features></Features>
      <HowItWorks></HowItWorks>
      <Business></Business>
      <Team></Team>
      {/* <InTheMedia></InTheMedia> */}
      {/* <MobileApp></MobileApp> */}
      <FAQ></FAQ>
      <Footer></Footer>
    </>
  );
}

export default App;
